export default "__VITE_ASSET__Bm$duoQi__"